import { FeatureToggles } from "../../context/ApplicationConfig";

export const handleSignIn = (history: any, toggles?: FeatureToggles) => {
  let redirectToAfterLogin = "/dashboard/home";
  const continueUrl = localStorage.getItem("continue_url_after_signin");
  localStorage.removeItem("continue_url_after_signin");
  history.push(continueUrl || redirectToAfterLogin);
};
